<template>
    <div class="container-fluid">
        <div class="row">      
            <Navbar :class="[mobile?'navbar-admin':'navbar-admin-mobile']" v-show="toggle"></Navbar>
            <div  :class="{ 'col-lg-12': !toggle }"  class="col-lg-9 col-md-12 col-xs-12">
              <div class="container">
                
                <Controls></Controls>
              
                <div class="row mt-4 mb-4 morado height50 hidden-xs">
                    <div class="avance-wrap mt-2 ">
                        <div class="avance-circulo activo"><h4>1</h4><div class="avance-circulo-interno"></div></div>
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>2</h4><div class="avance-circulo-interno"></div></div>  
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>3</h4><div class="avance-circulo-interno"></div></div>                                                
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>4</h4><div class="avance-circulo-interno"></div></div>                                
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>5</h4><div class="avance-circulo-interno"></div></div>                                
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>6</h4><div class="avance-circulo-interno"></div></div>                                
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>7</h4><div class="avance-circulo-interno"></div></div>
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>8</h4><div class="avance-circulo-interno"></div></div> 
                        <div class="avance-linea"></div>
                        <div class="avance-circulo activo"><h4>9</h4><div class="avance-circulo-interno"></div></div>                                                                    
                    </div>                                          
                </div>
                  <!--seccion pasos-->
                  <div class="row">
                      <div class="col-12">
                        <button class="btn btn-default btn-custom-fixed" @click='toggle = !toggle'> 
                          <font-awesome-icon v-show="toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-left']" /> 
                          <font-awesome-icon v-show="!toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-right']" /> 
                        </button>

                       <button class="d-xl-none btn btn-default btn-custom-fixed-mobile" @click='mobile = !mobile'> 
                          <font-awesome-icon style="z-index:2;"  :style="{ color: '#FFFFFF', position: 'absolute', left: '3', top: '2' }" size="2x" :icon="['fas', 'bars']" /> 
                        </button>

                            <div class="row">
                                <div class="col-12">
                                    <div class="col-md-12 col-sm-12 mx-auto">
                                        <div class="success">
                                            <div style="background-color:#662483" class="circular--portrait-check mt-5">
                                                <div class="text-center mt-4">
                                                    <font-awesome-icon :style="{ color: '#A2C037' }" size="7x" :icon="['fa', 'check']" />
                                                </div>
                                            </div>
                                            <h1 class="mt-5 text-center">Felicitaciones!!</h1>
                                            <p class="text-center">Estás a solo un paso de convertirte en anfitrión de House and Flats,
                                              <br>
                                              un ejecutivo se comunicará contigo lo antes posible.
                                            </p>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                                 

                      </div>
                  </div>
                  <!--fin seccion inputs-->
              </div>
            </div>
        </div>    
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Controls from '@/components/Controls.vue'
import Controls2 from '@/components/Controls2.vue'
import Steps from '@/components/Steps.vue'
import router from '@/router'

export default {
  name: 'Success',
  components: {
    Navbar,
    Controls,
    Controls2,
    Steps
  },
  data() {
    return {
     toggle: true,
     mobile : true,
    }
  },
  created () {
    setTimeout(function(){
       router.push({name: 'Dashboard'})
    }, 5000);    
  }      
}
</script>

<style scoped>
.dot {
  height: 25px;
  width: 25px;
   background-color: #F7F7F7;
  border-radius: 50%;
  display: inline-block;
  border: 1px;
  color: #5A287F;
  border-style: solid;
  border-width: 1px;
  border-color:#5A287F;
}
.btn-custom-fixed{
   background-color:#5A287F;
   color:white;
   width: 35px; 
   height: 60px;
   position: absolute;
   left: -50px;
   top: 60px;
}

@media (max-width: 991px) {
  .btn-custom-fixed{
   display: none;
  }
}

.opt-active{
  background-color: #5A287F;
  color: #FFFFFF;
  border-radius: 0;
}

.total{
  background-color: #5A287F;
  position: absolute;
  top:150px;
  width: auto;
}

.card-footer{
    background-color: #5A287F;
    color:white;
}

.recibe{
    background-color: #5A287F;
    color:white;
}

.o-container {
  padding-top: 40px;
  padding-bottom: 40px;
}

.c-field__error {
  font-size: 12px;
  color: #d71149;
}

.c-file-input {
  position: relative;
  display: block;
  height: 200px;
  width: 100%;
  border: 1px dashed #ddd;
  background-color: #fff;
}

/* line 24, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid,
.c-field--error .c-file-input {
  background-color: #ffe6e9;
  border-color: #ff566a;
}

/* line 28, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid:focus,
.c-field--error .c-file-input:focus {
  background-color: #ffe6e9;
  border-color: #ff566a;
}

/* line 34, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 36px;
  padding-right: 36px;
  line-height: 36px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  word-wrap: break-word;
  z-index: 1;
}

/* line 50, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field {
  position: absolute !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  z-index: -1;
}

/* line 59, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field:focus {
  outline: none;
}

/* line 64, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator {
  position: absolute;
  left:75px;
  top: 40px;
  height: 100%;
  width: 86px;
  z-index: 0;
}

/* line 73, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator__icon {
  color: #bbb;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
       -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
  left: 4px;
  font-size: 20px;
}

/* line 81, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.has-file .c-file-input__indicator__icon {
  color: #d71149;
}

/* line 86, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 36px;
  z-index: 2;
}

.has-file > .c-file-input__remove {
  display: block;
}

/* line 100, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove__icon {
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
       -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
  left: 4px;
  font-size: 20px;
  color: #ff566a;
}

.cortar {    
      white-space: nowrap;
      text-overflow:ellipsis;
      overflow: hidden;
}

.morado{
    background-color: #5A287F;
}
.height50{
   height: 50px; 
}
.avance-circulo.activo{
    background-color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color:#94C11F;
}

.avance-circulo{
    color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color:#94C11F;
}

  @media (max-width: 768px) {
  .hidden-xs {
    display: none !important;
  }
}

</style>

